import React from 'react'

import nz from '../../images/nz.png'
import residential from '../../images/residential.jpg'
import commercial from '../../images/commercial.jpg'
import reroofing from '../../images/reroofing.jpg'

class HomeServices extends React.Component {
  state = { show: false }

  componentDidMount() {
    if (this.props.loaderHidden) {
      this.setState({ show: true })
    }
  }

  componentWillReceiveProps(next) {
    if (next.loaderHidden && !this.props.loaderHidden) {
      this.setState({ show: true })
    }
  }

  render() {
    const residentialStyle = { background: `url(${residential}) no-repeat center center`, backgroundSize: 'cover'}
    const commercialStyle = { background: `url(${commercial}) no-repeat center center`, backgroundSize: 'cover'}
    const reroofingStyle = { background: `url(${reroofing}) no-repeat center center`, backgroundSize: 'cover'}
    const { show } = this.state
    return(
      <section className="home-services relative">
        <div className="home-services__inner">
          <div className="home-services__header">
            <h2>Our Services</h2>
            <p>Makuch Roofing provides a full range of roofing services across the <strong>Waikato</strong>, <strong>Bay of Plenty</strong> and <strong>Auckland</strong> regions. From large scale commercial buildings to new homes, roof replacements and guttering. No job is too big or too small.</p>
            <img className="nz" src={nz} alt="Auckland, Waikato and Bay of Plenty" />
          </div>
          <div className="home-services__blocks">

            <div style={show ? residentialStyle : {}} className="home-services__block">
              <div className="home-services__block-overlay" />
              <div className="home-services__block-inner">
                <h5>RESIDENTIAL</h5>
                <p>We offer a wide range of roofing solutions using materials designed specifically for the harsh New Zealand environment.</p>
              </div>
            </div>

            <div style={show ? commercialStyle : {}} className="home-services__block">
              <div className="home-services__block-overlay" />
              <div className="home-services__block-inner">
                <h5>COMMERCIAL</h5>
                <p>Makuch Roofing have proven experience with both small and large scale commercial roofing projects.</p>
              </div>
            </div>
            <div style={show ? reroofingStyle : null}  className="home-services__block">
              <div className="home-services__block-overlay" />
              <div className="home-services__block-inner">
                <h5>RE-ROOFING</h5>
                <p>Add value to your existing home or commercial building with a new roof.</p>
              </div>
            </div>

            <div className="home-services__block">
              <h5>OUR CUSTOMERS INCLUDE:</h5>
              <ul>
                <li>Commercial building owners</li>
                <li>Home owners</li>
                <li>Home renovators</li>
                <li>Real estate agents</li>
                <li>Schools</li>
                <li>Insurance companies</li>
                <li>New home builders</li>
                <li>Building maintenance managers</li>
              </ul>
            </div>

          </div>
        </div>
      </section>
    )
  }
}

export default HomeServices



// WEBPACK FOOTER //
// /opt/build/repo/src/components/home-page/HomeServices.js